
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// EXPORT this config so we can use it in authUtils for the secondary app
export const firebaseConfig = {
 apiKey: "AIzaSyAt9p3BGKBeNSF26npq2QELA3GIBMToScU",
  authDomain: "raktdaan-7a169.firebaseapp.com",
  databaseURL: "https://raktdaan-7a169-default-rtdb.firebaseio.com",
  projectId: "raktdaan-7a169",
  storageBucket: "raktdaan-7a169.appspot.com",
  messagingSenderId: "116685109840",
  appId: "1:116685109840:web:e1fa668c364e4c53fd6f55"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
